import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { RsHeadersPage } from 'src/app/shared/components/rs-headers/rs-headers.page'; 
import { RsMenuPage } from 'src/app/shared/components/rs-menu/rs-menu.page'; 

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, RsHeadersPage, RsMenuPage],
})
export class AppComponent {
  constructor() {}
}
